import React, { useState, useEffect,useRef,useCallback ,useContext} from "react";
import Input from "../common/inputfunction";
import {getDrivenlist} from '../../services/wms';
import Renderprofile from './renderdriven'
import  BranchContext from '../context/branch'

const SearchProfile = ({ updateData,search='' }) => {

  const [data, setData] = useState({
    search: search,
  });

  const {currentBranch} = useContext(BranchContext);
  const [master, setMaster] = useState([]);
  const [total,setTotal] = useState(0);
  const [hasMore, setHasMore] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [pageSize, setPageSize] = useState(30);
  const [id,setId] = useState(0);
 

  useEffect(() => {
    if (search !==''){
      setData({search: search})
    }


  }, [search]);


  useEffect(() => {
    setMaster([]);
  }, [
    currentBranch, data.search, pageSize]);


  useEffect(() => {
    if (!data.search) {
      return;
    }

  // if (data.search.length < 4) return;


    setLoading(true);
    setError(false);
    
    async function api() {
      try {
        const { data: result } = await getDrivenlist(currentBranch._id,data.search, pageSize,pageNumber);

        if (result.status === "success") {
          //  setTotal(result.data.total);
            setMaster(prevData => {   
                return [...new Set([...prevData, ...result.data.list])]
                             })
                      setHasMore(result.data.list.length > pageSize-1)
                      setLoading(false) 
           // setMaster(result.data.list);
        }

        //const employeeList = resService.data.data.search;

      //  console.log(employeeList);
      //  setMaster(employeeList);
      } catch (error) {
        // console.log(error);
      }
    }
    try {
      api();
    } catch (error) {}
  }, [currentBranch,pageSize,pageNumber]);

  const observer = useRef();
  const lastBookElementRef = useCallback(
    (node) => {

        
      if (loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setPageNumber((prevPageNumber) => prevPageNumber + 1);  
        }
      });
      if (node) observer.current.observe(node);
    },
    [loading, hasMore]
  );


  async function onSearchClick(event) {
    if (!data.search) {
      return;
    }

    if(event.key === 'Enter'){

    try {
      const { data: result } = await getDrivenlist (currentBranch._id,data.search, pageSize,
        pageNumber );

    //   if (!resService) {
    //     return;
    //   }

    //   const employeeList = resService.data.data.search;
    //   setMaster(employeeList);
   // console.log(result);
    if (result.status === "success") {
        setMaster(result.data.list);
    }
      
    } catch (error) {
      // console.log(error);
    }
  }
  }

  function handleChange({ currentTarget: input }) {
    const { name, value } = input;
  //  console.log("name,value=>", name, value);
    setData((previous) => {
      return {
        previous,
        [name]: value,
      };
    });
  }

  function handleOnselected({ currentTarget: input }) {
   
    const { name } = input;
   // console.log('you clicked on',master,name);

    const result = master.filter((i) => i._id == name);
    
   // console.log("result=>", result,result[0]);
    const data = result[0];
    updateData(data);
    

  }

 // console.log(master)
  return (
    <div className="form-group">
      <div className="row">
        <div className="col-sm-8">
          {/* <Input
          
         
          name="name"
          value={data.search}
          onChange={handleChange}
          type="search"
          placeholder={"ชื่อ/สกุล/เลขที่บัตรประชาชน"}
          onKeyPress ={onSearchClick}
         
          
          /> */}
        <input
 name="search"
 value={data.search}
 onChange={handleChange}
 type="search"
 placeholder={"ชื่อ-สกุล/รหัสบัตร"}
 onKeyPress ={onSearchClick}

          
           
          />
        </div>
      </div>
      <p className="text-success">
        แสดงข้อมูล {master ? master.length : 0}  /  {total} รายการ
      </p>
     
<Renderprofile
list ={master}
loading={loading}
error={error}
lastBookElementRef={lastBookElementRef}
handleOnselected={handleOnselected}
/>

    </div>
  );
};



export default SearchProfile;
